import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
} from "lucide-react";
import CustomTooltip from "./CustomTooltip";
const pageLimitOptions = [10, 25, 50, 100];
const Pagination = (props) => {
  Pagination.propTypes = {
    total: PropTypes.number,
    limit: PropTypes.number !== "NaN" ? PropTypes.number : "",
    currentPage: PropTypes.any,
    updateLimit: PropTypes.func,
    updatePage: PropTypes.func,
    from: PropTypes.number,
    to: PropTypes.number,
  };

  const [pages, setPages] = useState([1]);

  useEffect(() => {
    if (props.total) {
      let min = props.currentPage - 2;
      let max = Math.ceil(props.total / props.limit);
      if (min <= 0) {
        min = 1;
      }
      if (props.currentPage < max - 2) {
        max = props.currentPage + 2;
      }
      let page = [];
      for (let i = min; i <= max; i++) {
        page.push(i);
      }
      setPages(page);
    }
  }, [props.total, props.limit, props.currentPage]);

  return (
    <>
      {props?.total !== 0 &&
        props?.total !== undefined &&
        props?.total !== null && (
          <div
            className={`table-pagination dark:bg-muted bg-webSecondary dark:text-foreground text-white rounded-md mt-1 px-4 sticky bottom-0`}
          >
            <div className="limiter">
              Showing{" "}
              <select
                onChange={(element) => props.updateLimit(element)}
                defaultValue={props.limit !== "NaN" ? props.limit : 0}
                className="font-bold text-white !bg-webPrimary rounded-sm px-0.5"
              >
                {pageLimitOptions.map((opt) => {
                  return <option key={opt} className="bg-white text-black">{opt}</option>;
                })}
              </select>{" "}
              Records per page
              {props.from &&
                props.to &&
                props.total &&
                ` | Showing ${props.from} to ${props.to} from ${props.total} Records`}
            </div>

            <div className="pager">
              {props.currentPage !== 1 ? (
                <>
                  <CustomTooltip message="First">
                    <button
                      onClick={() => props.updatePage(1)}
                      className="bg-webPrimary border border-webPrimary text-white rounded-full w-[25px] h-[25px] flex items-center justify-center"
                    >
                      <ChevronsLeft size={20} />
                    </button>
                  </CustomTooltip>
                  <CustomTooltip message="Prev">
                    <button
                      onClick={() => props.updatePage(props.currentPage - 1)}
                      className="bg-webPrimary border border-webPrimary text-white rounded-full w-[25px] h-[25px] flex items-center justify-center"
                    >
                      <ChevronLeft size={20} />
                    </button>
                  </CustomTooltip>
                </>
              ) : null}
              <ul className="pages">
                {pages.map((page, index) => {
                  return (
                    <li
                      onClick={() => props.updatePage(page)}
                      key={"apge" + index}
                      className={page === props.currentPage ? "active" : ""}
                    >
                      <button>{pages?.length === 1 ? "" : page}</button>
                    </li>
                  );
                })}
              </ul>
              {props.currentPage !== Math.ceil(props.total / props.limit) &&
              props?.total > props?.to ? (
                <>
                  <CustomTooltip message="Next">
                    <button
                      onClick={() => props.updatePage(props.currentPage + 1)}
                      className="bg-webPrimary border border-webPrimary text-white rounded-full w-[25px] h-[25px] flex items-center justify-center"
                    >
                      <ChevronRight size={20} />
                    </button>
                  </CustomTooltip>
                  <CustomTooltip message="Last">
                    <button
                      onClick={() =>
                        props.updatePage(Math.ceil(props.total / props.limit))
                      }
                      className="bg-webPrimary border border-webPrimary text-white rounded-full w-[25px] h-[25px] flex items-center justify-center"
                    >
                      <ChevronsRight size={20} />
                    </button>
                  </CustomTooltip>
                </>
              ) : null}
            </div>
          </div>
        )}
    </>
  );
};

export default Pagination;
